import {observer} from "mobx-react";
import * as React from "react";
import {observable} from "mobx";
import './QuizQuestion.pcss';

interface IQuizQuestion_Props {
  children:any;
}

@observer
export class QuizQuestion extends React.Component<IQuizQuestion_Props> {

  render() {
    return (
      <div className={'quizQuestion'}>
        {this.props.children}
      </div>
    );
  }


}
